
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.913 12.932h.16c1.455-.025 2.633-.537 3.503-1.516 1.913-2.157 1.595-5.855 1.56-6.207-.124-2.65-1.376-3.917-2.41-4.508-.77-.443-1.67-.681-2.674-.701h-.085c-.551 0-1.634.09-2.673.68-1.044.592-2.316 1.86-2.44 4.529-.035.352-.353 4.05 1.56 6.207.865.98 2.043 1.491 3.499 1.516zm-3.732-7.6c0-.014.005-.029.005-.039.164-3.563 2.693-3.946 3.777-3.946h.06c1.341.03 3.623.576 3.777 3.946 0 .015 0 .03.005.04.005.035.352 3.414-1.228 5.193-.626.706-1.461 1.054-2.56 1.064h-.049c-1.094-.01-1.934-.358-2.555-1.064-1.575-1.769-1.237-5.163-1.232-5.193z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M22.206 19.065v-.015c0-.04-.005-.08-.005-.124-.03-.984-.095-3.286-2.252-4.021l-.05-.015c-2.24-.572-4.104-1.864-4.124-1.879a.67.67 0 10-.77 1.099c.084.06 2.062 1.436 4.537 2.072 1.158.413 1.287 1.65 1.322 2.783 0 .045 0 .085.005.125.005.447-.025 1.138-.104 1.535-.806.457-3.962 2.038-8.763 2.038-4.78 0-7.956-1.585-8.767-2.043-.08-.397-.114-1.088-.104-1.535 0-.04.005-.08.005-.125.035-1.133.164-2.37 1.322-2.783 2.475-.636 4.453-2.018 4.538-2.072a.67.67 0 10-.77-1.099c-.02.015-1.874 1.307-4.126 1.879a.626.626 0 00-.05.015c-2.156.74-2.221 3.042-2.25 4.02 0 .045 0 .085-.006.125v.015c-.005.258-.01 1.585.254 2.251.05.13.139.239.258.313.15.1 3.723 2.376 9.701 2.376 5.98 0 9.553-2.281 9.702-2.376a.666.666 0 00.258-.313c.249-.66.244-1.988.239-2.246z","fill":"currentColor"}})])
          )
        }
      }
    